export default __webpack_public_path__ + "static/media/car-play_40px.3bdfeab3.svg";